import React from "react";
import data from "./data";
import {Button, Col, Row} from "antd";
import ReactGA from "react-ga";

const Banner : React.FC = () => {
    return (
        <section className={"main-banner"}>
           <div className={"public-container"}>
               <Row gutter={[50, 30]} className={"describe"}>
                   <Col md={{push : 13, span : 11}}  sm={24} xs={24}>
                       <div className={"sub-banner"}>
                           <img src={"/images/banner/portofolio-banner.svg"} alt={"WASDLABS BANNER"} />
                       </div>
                   </Col>
                   <Col md={{pull : 11, span : 13}} sm={24} xs={24}>
                       <div className={"section-heading"}>
                           <h1>{data.banner.id.title}</h1>
                           <p>{data.banner.id.subTitle}</p>
                           <Button
                               type={"primary"}
                               size={"large"}
                               href={"https://wa.me/6285656284641"}
                               onClick={() => ReactGA.event({category : "Contact", action : "clicked", label : "Call_now" })}
                           >
                               {data.banner.id.buttonText}
                           </Button>
                       </div>
                   </Col>
               </Row>
           </div>
        </section>
    )
}

export default React.memo(Banner);